import { useMemo } from 'react'
import { IAwardedLaneFragment } from '../../../../graphql/AwardedLaneFragment'
import { ISidebarListDataItem } from '../SidebarListData'

type TRmsDetails = Partial<Pick<IAwardedLaneFragment, 'id' | 'shipperLaneId'>>

export const useRmsDetails = ({ id, shipperLaneId }: TRmsDetails): ISidebarListDataItem[] =>
  useMemo(() => {
    return [
      {
        label: 'Award ID',
        value: id,
        dataTest: 'rate-id',
      },
      {
        label: 'Lane ID',
        value: shipperLaneId,
      },
    ]
  }, [id, shipperLaneId])
